import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonInput, IonModal, IonItem, IonContent, IonText} from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from './TakePhoto';
import { AddSupplierModal } from './Modal_AddSupplier';

import {v4 as uuid} from 'uuid';

import '../css/zInternal_css.css';


export function AddExpenseModal_Projects (props) {


    let supplierNameRef = useRef(props.data.supplier_name);
    let supplierPhoneRef = useRef(props.data.supplier_phoneNumber);
    let expenseDescriptionRef = useRef('');
    let unitAmountRef = useRef('');
    let quantityRef = useRef('1');
    //let totalAmountRef = useRef();
    let paymentTypeRef = useRef('mobile_money');
    //let selectedFileRef = useRef('');

    let [quantity_state, setQuantity_state] = useState(1);
    let [paymentType_state, setPaymentType_state] = useState('mobile_money');

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showPasswordModal, setShowPasswordModal] = useState(false); 
    let [showSupplierModal , setShowSupplierModal] = useState(false);
    //let [enteredPassword, setEnteredPassword] = useState('');
    let [searchResults, setSearchResults] = useState([]);

    let [takePhotoStatus, setTakePhotoStatus] = useState(false);
    let [selectedFile, setSelectedFile] = useState(null);
    let [expenseInvoiceAttachement, setExpenseInvoiceAttachment] = useState('/var/www/web/Public/fileServer/merchants/attachment-not-available.png');

    //let [supplierName, setSupplierName] = useState('');
    //let [supplierPhone, setSupplierPhone] = useState('');

    let [momo_provider, setMomoProvider] = useState('');
    let [momo_financial_transaction_id, setFinancialTransactionId] = useState(''); 
    let [momo_external_id, setExternalId] = useState('');
    let [momo_amount, setAmount] = useState('');
    let [momo_currency, setCurrency] = useState('');
    let [momo_party_id_type, setPartyIdType] = useState('');
    let [momo_party_id, setPartyId] = useState('');
    let [momo_payer_message, setPayerMessage] = useState('');
    let [momo_payee_note, setPayeeNote] = useState('');
    let [momo_pay_status, setPayStatus] = useState('');

    let [disableExpensePayButton, setDisableExpensePayButton] = useState(false);
    let [disableRefundButton, setDisableRefundButton] = useState(false);

    let [disablePayButton, setDisablePayButton] = useState(false);

    //let [selectedFile_upload, setSelectedFile_upload] = useState<File | null>(null);
    let [fileName, setFileName] = useState('');

    let [updateSupplier, setUpdateSupplier] = useState('no');

    //let [supplierName, setSupplierName] = useState(null);
    //let [supplierPhone, setSupplierPhone] = useState(null);


    function handleEnterAttachement() {  

        fetch(baseURL+'fileServer/merchants/attachment-not-available.png')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setExpenseInvoiceAttachment(noImageFile);

        })
    }

    function handleFileChange(event) {

        //alert('In handleFileChange');
        //alert(event);
        //alert(event.target);
        //alert(event.target.files);
        //alert(event.target.file);
        const file = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);
        //setFileName(file ? file.name : '');
    }


    function addExpense(enteredPassword)
    {

        // alert("IN ADD EXPENSE PROJECTS 1");
        // alert(acctID);
        // alert(props.data.projectID);
        // alert(supplierNameRef.current.value);
        // alert(supplierPhoneRef.current.value);
        // alert(expenseDescriptionRef.current.value);
        // alert(unitAmountRef.current.value);
        // alert(paymentType_state);
        // alert(sessionID);
        // alert(selectedFile);

        //let totalExpenseAmount = +unitAmountRef.current.value * +quantity_state;
        
        let formData = new FormData();
        formData.append('Tracker', '74002B_add_expense_project');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('fmc_schema', schema);
        formData.append('xProjectID', props.data.projectID);
        formData.append('xSupplierName', supplierNameRef.current);
        formData.append('xSupplierPhoneNumber', supplierPhoneRef.current);
        //formData.append('xSupplierEmailAddress', supplierEmailAddressRef.current.value);
        //formData.append('xSupplierAddressNumber', supplierAddressNumberRef.current.value);
        //formData.append('xSupplierStreetName', supplierStreetNameRef.current.value);
        //formData.append('xSupplierCity', supplierCityRef.current.value);
        //formData.append('xSupplierCityDistrict', supplierCityDistrictRef.current.value);
        //formData.append('xSupplierCountryRegion', supplierCountryRegionRef.current.value);
        //formData.append('xSupplierCountry', supplierCountryRef.current.value);
        //formData.append('xSupplierDigitalAddressID', employeeDigitalAddressIDRef.current.value)
        formData.append('xExpenseDescription', expenseDescriptionRef.current.value);
        //formData.append('xExpenseUnitAmount', unitAmountRef.current.value);
        //formData.append('xExpenseQuantity', quantity_state);
        formData.append('xExpenseTotalAmount', unitAmountRef.current.value);
        formData.append('xPaymentType', paymentType_state);
        formData.append('xEnterAdminPassword', enteredPassword);
        formData.append('sessionID', sessionID);
        formData.append('xImageFile', selectedFile);

        alert("IN ADD EXPENSE PROJECTS 2");
        alert(baseURL);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        



       /* const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74002B',
                user: acctID,
                xSupplierName: supplierNameRef.current.value,
                xSupplierPhoneNumber: supplierPhoneRef.current.value,
                // xSupplierEmailAddress: supplierEmailAddressRef.current.value,
                // xSupplierAddressNumber: supplierAddressNumberRef.current.value,
                // xSupplierStreetName: supplierStreetNameRef.current.value,
                // xSupplierCity: supplierCityRef.current.value,
                // xSupplierCityDistrict: supplierCityDistrictRef.current.value,
                // xSupplierCountryRegion: supplierCountryRegionRef.current.value,
                // xSupplierCountry: supplierCountryRef.current.value,
                // xSupplierDigitalAddressID: employeeDigitalAddressIDRef.current.value,
                xExpenseDescription: expenseDescriptionRef.current.value,
                xExpenseUnitAmount: unitAmountRef.current.value,
                xExpenseQuantity: quantityRef.current.value,
                xExpenseTotalAmount: totalExpenseAmount,
                xPaymentType: paymentTypeRef.current.value,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,
                xSupportingDocumentation: selectedFile,

            })
        }*/
        alert("IN ADD EXPENSE PROJECTS 3");

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            setDisableExpensePayButton(false);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }


    function searchSupplierList(event)
    {

        let searchCategory = event[0];
        let searchData = event[1];


        first_searchSuppliersInDB(searchCategory, searchData);


        /*let searchData;
        let optionsData;
        let list;

        if(searchCategory === 'name')
        {
            searchData = document.getElementById('searchSupplierName').value;
            optionsData = document.getElementById('searchSupplierNameList').childNodes;
            list = 'searchSupplierNameList';
        }
        else if(searchCategory === 'phone')
        {
            searchData = document.getElementById('searchSupplierPhoneNumber').value;
            optionsData = document.getElementById('searchSupplierPhoneNumberList').childNodes;
            list = 'searchSupplierPhoneNumberList';
        }



        for (let i = 0; i < optionsData.length; ++i)
        {

            if(optionsData[i].text === searchData)
            {

                supplierSearchResults(optionsData[i].dataset.id);
                break;
            }

            else if (i === optionsData.length - 1)
            {

                if (searchData.length > 1)
                {

                    searchSuppliersInDB(searchCategory, searchData, optionsData);
                }
                else if (searchData.length === 0)
                {

                    let optionsData = document.getElementById(list).childNodes;

                    for (let i = 0; i < optionsData.length; ++i)
                    {


                        let remove = document.getElementsByClassName('forRemoveProjectSearch');

                        while(remove.length > 0)
                        {
                            remove[0].parentNode.removeChild(remove[0]);
                        }
                    }

                    break;
                }
                else
                {

                    first_searchSuppliersInDB(searchCategory, searchData, optionsData);
                }
            }
        }*/
    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {
        //let searchData = document.getElementById('searchInventoryItem').value;
        //let optionsData = document.getElementById('searchInventoryItemsList').childNodes;


        /*for (let i = 0; i < optionsData.length; ++i)
        {
            let remove = document.getElementsByClassName('forDontRemoveProjectSearch');

            while(remove.length > 0)
            {
                remove[0].parentNode.removeChild(remove[0]);
            }
        }*/


        let formData = new FormData();
        let Tracker = '';


        if(searchCategory === 'name')
        {
            /*
            formData.append('Tracker', '74002S_N');
            formData.append('user', acctID);
            formData.append('xSupplierSearchName', searchData);
            */

            Tracker = '74002S_N';
        }
        else if(searchCategory === 'phone')
        {
             /*
            formData.append('Tracker', '74002S_P');
            formData.append('user', acctID);
            formData.append('xSupplierSearchPhone', searchData);
            */

            Tracker = '74002S_P';

        }


        /*const requestOptions = {
            method: 'POST',
            credentials: 'include',
            body: formData
        }*/

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xSupplierSearchName: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                if(searchCategory === 'name')
                                {
                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            db_supplierId: cols[0],
                                            db_supplierName: cols[1],
                                            db_supplierPhoneNumber: cols[2],
                                            db_supplierAddressNumber: cols[3],
                                            db_supplierStreetName: cols[4],
                                            db_supplierCity: cols[5],
                                            db_supplierCountry: cols[6],
                                        })
                                    });
                                    //document.getElementById('searchSupplierNameList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+[cols[0], cols[1], searchCategory,]+'\'>'+cols[0]+'</option>'); // onclick=\'inventoryItemsSearchResults('+cols[0]+')\'
                                }
                                else if(searchCategory === 'phone')
                                {

                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            db_supplierId: cols[0],
                                            db_supplierName: cols[1],
                                            db_supplierPhoneNumber: cols[2],
                                            db_supplierAddressNumber: cols[3],
                                            db_supplierStreetName: cols[4],
                                            db_supplierCity: cols[5],
                                            db_supplierCountry: cols[6],
                                        })
                                    });
                                }
                            }
                    })
        }

    function paymentFunction(event)
    {

        setDisableExpensePayButton(true);
 

        if(event[5] == "partial_paid")
        {

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74108_B_expense_pay_projects',
                    user: acctID,
                    xCustMobileNumber: event[0][1],
                    xInvoiceID: event[0][7],
                    xCustomerInvoiceID: event[0][8],
                    xImmediateDestination: acctID,
                    xCheckInCashAmount: parseFloat(event[0][0]).toFixed(2),
                    sessionID: sessionID,
                    xPaymentType: event[1],
                    xMomo_provider: event[2],
                    xMomo_financial_transaction_id: event[3],
                    xMomo_external_id: event[4],
                    xMomo_amount: event[5],
                    xMomo_currency: event[6],
                    xmomo_party_id_type: event[7],
                    xMomo_party_id: event[8],
                    xMomo_payer_message: event[9],
                    xMomo_payee_note: event[10],
                    xMomo_pay_status: event[11],
    
                }),
            }

            fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(data => {

                addExpense('reaper');
                alert('Payment Sent To Customer');

                //confirmPayment_non_member([data, event[0][1], event[0][2], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], event[4], event[5], event[6], event[7], event[8], event[9], event[10], event[11]]);

            })
            .catch(error => {
                console.error(error);
            })
        }
        else if(event[5] == "initial")
        { 

                const date = new Date();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
                const day = String(date.getDate()).padStart(2, '0');
                const year = date.getFullYear();

            const requestOptions0 = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74706_initial_expense_projects',
                    user: acctID,
                    xProjectID: props.data.projectID,
                    xInvoiceID: props.data.invoiceID,
                    xCustomerInvoiceID: props.data.customerInvoiceID,
                    xSupplierName: event[2],
                    //xCheckInLastName: event[0][8],
                    xExpensePayMobileNumber: event[1],
                    //xCheckInEmail: event[0][10],
                    //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                    //xCheckInNonMemberIDNumber: enterID_numberRef.current.value,
                    //xSupportingDocumentation: selectedFile,
                    xExpenseInvoiceAttachment: expenseInvoiceAttachement,
                    xPaymentType: "MTN-MOMO",
                    xExpenseTotalAmount: parseFloat(event[0]).toFixed(2),
                    xExpensePayDateSent: `${month}/${day}/${year}`,
                    //xExpenseID: props.data.bookingID,
                    sessionID: sessionID,
                }),
            }
    
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions0)
            .then(res => res.text())
            .then(data0 => {
    
                            let cols = data0.toString().split('|');

                            return new Promise((resolve, reject) => {

                                const customerPayAmount = parseFloat(event[0]).toFixed(2);
                                const payCurrency = 'GHS';
                                //const payExternalId = '';
                                const payPartyId = event[1].replace(/^0+/, '');
                                const payPayerMessage = event[2] + " Momo Payment";
                                const payPayeeNote = "Bluefin Hotel Invoice";
                    
                                const apiuser = "0a8356fc-ce44-4436-a976-68a954d94094";
                                const apikey = "9070094e5ece4fabb351a0e282043cee";
                                const concatenatedString = `${apiuser}:${apikey}`;
                                const base64EncodedString = window.btoa(concatenatedString);
                    
                                let xReferenceID = uuid();
                    
                                fetch(baseURL+'mtnapi2/disbursement/token/', {
                                    method: 'POST',                                                                                                                                                                                                                 
                                    //credentials: 'include',
                                    //mode: 'no-cors',
                                    //body: '',
                                    //Request headers
                                    headers: {
                                        'authorization': 'Basic '+ base64EncodedString,
                                        //'cache-Control': 'no-cache',
                                        //'content-_type': 'application/json',
                                        'ocp-apim-subscription-key': 'ff1585eb2f8a41d29771cca4238c02d3',
                                        'x-target-environment': 'mtnghana',
                                        'x-reference-id': xReferenceID.toString(),
                                        'user': acctID,
                                        'schema': schema,
                                        'x_merchant_mobilenumber': authenticatedMerchent_context.companyPhoneNumber,
                                        'x_project_id': props.data.projectID,
                                        'x_customer_mobilenumber': event[1],
                                        'x_invoice_id': cols[0],
                                        'x_customer_invoice_id': props.data.customerInvoiceID,
                                        'x_immediate_destination': acctID,
                                        'x_check_in_amount': parseFloat(event[0]).toFixed(2),
                                        'session_id': sessionID,
                                        'momo_url': 'disbursement/v1_0/'+event[4],
                                        'confirm_payment': 'confirm_or_reject',
                                        // 'request_to_pay': JSON.stringify({
                                        //     "amount": customerPayAmount,
                                        //     "currency": payCurrency,
                                        //     "externalId": xReferenceID.toString(),
                                        //     "payer": {
                                        //         "partyIdType": "MSISDN",
                                        //         "partyId": "233"+payPartyId
                                        //     },
                                        //     "payerMessage": payPayerMessage,
                                        //     "payeeNote": payPayeeNote
                                        // }),
                                        'customer_pay_amount': customerPayAmount,
                                        'pay_currency': payCurrency,
                                        'external_id': xReferenceID.toString(),
                                        'party_id_type': 'MSISDN',
                                        'party_id': payPartyId,
                                        'pay_payer_message': payPayerMessage,
                                        'pay_payee_note': payPayeeNote,
                    
                                    },
                    
                                })
                                .then(res => res.json())
                                .then(res => {
                                    
                                    if(res.status == "SUCCESSFUL")
                                    {

                                        const requestOptions = {
                                            method: 'POST',
                                            //credentials: 'include',
                                            headers: {
                                                'Accept': 'text/html, application/json',
                                                'content-type': 'application/json',
                                                //'cookie': 'cookie',
                                            },
                                            body: JSON.stringify({
                                                Tracker: '74108_B_expense_pay_projects',
                                                user: acctID,
                                                xProjectID: props.data.projectID,
                                                xCustMobileNumber: event[1],
                                                xInvoiceID: cols[0],
                                                xCustomerInvoiceID: props.data.customerInvoiceID,
                                                xImmediateDestination: acctID,
                                                xCheckInCashAmount: parseFloat(event[0]).toFixed(2),
                                                sessionID: sessionID,
                                                xPaymentType: 'MTN-MOMO',
                                                xMomo_provider: 'MTN',
                                                xMomo_financial_transaction_id: res.financialTransactionId,
                                                xMomo_external_id: res.externalId,
                                                xMomo_amount: res.amount,
                                                xMomo_currency: 'GHS',
                                                xmomo_party_id_type: res.payee.partyIdType,
                                                xMomo_party_id: res.payee.partyId,
                                                xMomo_payer_message: res.payerMessage,
                                                xMomo_payee_note: res.payeeNote,
                                                xMomo_pay_status: res.status,           
                                
                                            }),
                                        }
                
                                        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
                                        .then(res2 => res2.text())
                                        .then(res2 => {


                                            addExpense('reaper');
                                            alert('Payment Sent To Customer');
                
                                        })
                                        .catch(error => {
                                            console.error(error);
                                        })

                                    }
                                    else
                                    {
                                        alert('PAYMENT NOT SUCCESSFULL');
                                    }

                                })
                            })
    
                })
        }
        else if(event[5] == "admin")
        { 

                const date = new Date();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
                const day = String(date.getDate()).padStart(2, '0');
                const year = date.getFullYear();

            const requestOptions0 = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74706_initial_expense_projects',
                    user: acctID,
                    xProjectID: props.data.projectID,
                    xInvoiceID: props.data.invoiceID,
                    xCustomerInvoiceID: props.data.customerInvoiceID,
                    xSupplierName: event[2],
                    //xCheckInLastName: event[0][8],
                    xExpensePayMobileNumber: event[1],
                    //xCheckInEmail: event[0][10],
                    //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                    //xCheckInNonMemberIDNumber: enterID_numberRef.current.value,
                    //xSupportingDocumentation: selectedFile,
                    xExpenseInvoiceAttachment: expenseInvoiceAttachement,
                    xPaymentType: "MTN-MOMO",
                    xExpenseTotalAmount: parseFloat(event[0]).toFixed(2),
                    xExpensePayDateSent: `${month}/${day}/${year}`,
                    //xExpenseID: props.data.bookingID,
                    sessionID: sessionID,
                    
                }),
            }
    
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions0)
            .then(res => res.text())
            .then(data0 => {
    
                            let cols = data0.toString().split('|');

                            return new Promise((resolve, reject) => {

                                const customerPayAmount = parseFloat(event[0]).toFixed(2);
                                const payCurrency = 'GHS';
                                //const payExternalId = '';
                                const payPartyId = event[1].replace(/^0+/, '');
                                const payPayerMessage = event[2] + " Momo Payment";
                                const payPayeeNote = "Bluefin Hotel Invoice";
                    
                                const apiuser = "28fd26ad-0cda-49a2-ad90-15083276a26a";
                                const apikey = "218c665182e447538d0e6ac6f36ad3b4";
                                const concatenatedString = `${apiuser}:${apikey}`;
                                const base64EncodedString = window.btoa(concatenatedString);
                    
                                let xReferenceID = uuid();
                    
                    

                                        const requestOptions = {
                                            method: 'POST',
                                            //credentials: 'include',
                                            headers: {
                                                'Accept': 'text/html, application/json',
                                                'content-type': 'application/json',
                                                //'cookie': 'cookie',
                                            },
                                            body: JSON.stringify({
                                                Tracker: '74108_B_expense_pay_projects',
                                                user: acctID,
                                                xProjectID: props.data.projectID,
                                                xCustMobileNumber: event[1],
                                                xInvoiceID: cols[0],
                                                xCustomerInvoiceID: props.data.customerInvoiceID,
                                                xImmediateDestination: acctID,
                                                xCheckInCashAmount: parseFloat(event[0]).toFixed(2),
                                                sessionID: sessionID,
                                                xPaymentType: 'MANUAL_MOMO_MTN',
                                                xMomo_provider: 'MTN',
                                                xMomo_financial_transaction_id: 'N/A',
                                                xMomo_external_id: xReferenceID,
                                                xMomo_amount: customerPayAmount,
                                                xMomo_currency: 'GHS',
                                                xmomo_party_id_type: 'MDSISDN',
                                                xMomo_party_id: payPartyId,
                                                xMomo_payer_message: payPayerMessage,
                                                xMomo_payee_note: payPayeeNote,
                                                xMomo_pay_status: 'SUCCESSFUL',           
                                
                                            }),
                                        }
                
                                        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
                                        .then(res2 => res2.text())
                                        .then(res2 => {
                                            

                                            confirmPayment_non_member([res2, event[1], event[2], cols[1], event[3], 'MANUAL_MOMO_MTN-MOMO', 'MTN', 'N/A', xReferenceID, customerPayAmount, 'GHS', 'MDSISDN', payPartyId, payPayerMessage, payPayeeNote, 'SUCCESSFUL', 'admin_pay', cols[0]]);
                
                                        })
                                        .catch(error => {
                                            console.error(error);
                                        })


                            })
    
                })
        }

    }


    function confirmPayment_non_member(event)
    {

        let supplierName = event[2];
        let tracker = event[4];
        let customerInvoiceID = event[3];
        let transactionID = event[0];
        let customerPhoneNumber = event[1];

        /*
        let formData = new FormData();
        formData.append('Tracker', tracker);
        formData.append('xCustomerInvoiceID', customerInvoiceID);
        formData.append('xTransactionID', transactionID);
        formData.append('xCustMobileNumber', customerPhoneNumber);
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[5]);

        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: tracker,
                user: acctID,
                xProjectID: props.data.projectID,
                xCustomerInvoiceID: props.data.customerInvoiceID,
                xTransactionID: transactionID,
                xCustMobileNumber: customerPhoneNumber,
                xSupplierName: supplierName,
                sessionID: sessionID,
                xPaymentType: event[5],
                xMomo_provider: event[6],
                xMomo_financial_transaction_id: event[7],
                xMomo_external_id: event[8],
                xMomo_amount: event[9],
                xMomo_currency: event[10],
                xmomo_party_id_type: event[11],
                xMomo_party_id: event[12],
                xMomo_payer_message: event[13],
                xMomo_payee_note: event[14],
                xMomo_pay_status: event[15], 

            }),
        }

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

                addExpense('reaper');
                alert('Payment Sent To Customer');

                    const requestOptions = {
                        method: 'POST',
                        //credentials: 'include',
                        headers: {
                            'Accept': 'text/html, application/json',
                            'content-type': 'application/json',
                            //'cookie': 'cookie',
                        },
                        url: '/momo_payment_confirmed',
                        body: JSON.stringify({
                            Tracker: '74108_B_update_successful_projects',
                            user: acctID,
                            xProjectID: props.data.projectID,
                            xCustMobileNumber: customerPhoneNumber,
                            xInvoiceID: event[17],
                            xCustomerInvoiceID: customerInvoiceID,
                            xImmediateDestination: acctID,
                            xCheckInCashAmount: event[9],
                            sessionID: sessionID,
                            xMomo_provider: event[6],
                            xMomo_financial_transaction_id: event[7],
                            xMomo_external_id: event[8],
                            xMomo_amount: event[9],
                            xMomo_currency: event[10],
                            xmomo_party_id_type: event[11],
                            xMomo_party_id: event[12],
                            xMomo_payer_message: event[13],
                            xMomo_payee_note: event[14],
                            xMomo_pay_status: event[15],                                          
                            }),
                        }

                        fetch(baseURL+'momo_payment_confirmed', requestOptions)
                        .then(res => res.text())
                        .then(data => {

                            alert(data);

                        })


        })
    }


    function selectedFileHandler(event)
    {
        setSelectedFile(event);

    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        addExpense('reaper');
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    let timeout;

    function handleInput(event) {

        document.getElementById('searchSupplierNameList').innerHTML = '';
        document.getElementById('searchSupplierPhoneNumberList').innerHTML = '';

        clearTimeout(timeout); // Clear the previous timeout to reset the delay
        timeout = setTimeout(searchSupplierList(event), 2000); // Set a new timeout
    
    }


    function isJPEG(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            
            reader.onloadend = function() {
                const arr = new Uint8Array(reader.result).subarray(0, 4);
                let header = "";
                for (let i = 0; i < arr.length; i++) {
                    header += arr[i].toString(16);
    
                }
                
                // JPEG magic number: 0xFFD8
                if (header === "ffd8") {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
    
            reader.onerror = function() {
                reject(new Error("Error reading blob"));
            };
    
            reader.readAsArrayBuffer(blob.slice(0, 4));
        });
    }

    //alert(supplierNameRef.current);
    //alert(supplierPhoneRef.current);



    return (

            <React.Fragment>
                {
                props.openModal == true ?
                (
                    <IonModal isOpen={ props.openModal }>
                    <IonContent className='bookedDetails_gridContent_multiple'>
                    <IonSlides pager='true' className='custom-pagination' options={{ speed: 100 }}>

                        <IonSlide>
                                <IonGrid className='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <h2 for='searchSupplierName'>Supplier Name:</h2>
                                        </IonCol>
                                       {/*} <IonCol>
                                            <input type='text' id='searchSupplierName' ref={ supplierNameRef } placeholder='Search supplier name' onInput={() => handleInput(['name', supplierNameRef.current.value])} list='searchSupplierNameList' autocomplete='off' required></input>
                                            <datalist id='searchSupplierNameList'>
                                                {searchResults.map((result) => (
                                                    <option key={result.db_supplierId} value={result.db_supplierName}></option>
                                                ))}
                                            </datalist>
                                                </IonCol>*/}
                                        <IonCol>
                                            <IonText>{props.data.supplier_name}</IonText>
                                        </IonCol>
                                       {/*} {updateSupplier == 'no' && <IonCol>
                                            <IonButton onClick={() => setUpdateSupplier('yes')}>CHANGE</IonButton>
                                        </IonCol>}
                                        {updateSupplier == 'yes' && <IonCol>
                                            <IonButton onClick={() => setUpdateSupplier('no')}>RESET</IonButton>
                                                </IonCol>}*/}
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <h2 for='searchSupplierPhoneNumber'>Supplier Phone Number:</h2>
                                        </IonCol>
                                       {/*<IonCol>
                                            <input type='text' id='searchSupplierPhoneNumber' ref={ supplierPhoneRef }  placeholder='Search supplier phone number' onInput={() => handleInput(['phone', supplierPhoneRef.current.value])} list='searchSupplierPhoneNumberList' autocomplete='off' required></input>
                                            <datalist id='searchSupplierPhoneNumberList'>
                                                {searchResults.map((result) => (
                                                    <option key={result.db_supplierId} value={result.db_supplierPhoneNumber}></option>
                                                ))}
                                            </datalist>
                                                </IonCol>*/}
                                      <IonCol>
                                            <IonText>{props.data.supplier_phoneNumber}</IonText>
                                        </IonCol>
                                    </IonRow>
                                    {/*<IonRow>
                                        <IonCol>
                                            <IonButton  onClick={() => setShowSupplierModal(true)}> Add Supplier</IonButton>
                                        </IonCol>
                                    </IonRow>*/}
                                </IonGrid>

                            <AddSupplierModal  openModal={ showSupplierModal } closeModal={() => setShowSupplierModal(false)}></AddSupplierModal>
                        </IonSlide>
                        {/*<IonSlide>
                            <IonItem>
                                <IonLabel>Supplier City District: </IonLabel>
                                <IonInput placeholder='Enter Digital Address' ref={ employeeDigitalAddressIDRef }></IonInput>
                            </IonItem>
                        </IonSlide>
                        <IonSlide>
                            <IonItem>
                                <IonLabel>Supplier Digital Address ID: </IonLabel>
                                <IonInput placeholder='Enter Digital Address' ref={ employeeDigitalAddressIDRef }></IonInput>
                            </IonItem>
                        </IonSlide>*/}
                        <IonSlide>
                                <IonGrid  className='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <IonLabel>Expense Description: </IonLabel>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonInput type='text' placeholder='Enter Description' ref={ expenseDescriptionRef }></IonInput>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonSlide>
                        <IonSlide>
                                <IonGrid className='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <IonLabel>Unit Amount: </IonLabel>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonInput type='text' placeholder='Enter Unit Amount' ref={ unitAmountRef }></IonInput>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonSlide>
                        {/*<IonSlide >
                                <IonGrid class='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <IonLabel>Quantity: </IonLabel>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonInput type='number' placeholder='Enter Qty' ref={ quantityRef }></IonInput>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonSlide>
                        <IonSlide>
                                <IonGrid class='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <IonLabel for="employeeRole">Payment Type </IonLabel>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <select name="employeeRole" id='employeeRole' ref={paymentTypeRef }>
                                                <option value='cash'>Cash</option>
                                                <option value='mobile_money' selected>Mobile Money</option>
                                            </select>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonSlide>*/}
                        <IonSlide>
                                <IonGrid className='gridText'>
                                    <IonRow>
                                        <IonCol>                            
                                            <IonButton  onClick={() => setTakePhotoStatus(true)}> Take Photo</IonButton>
                                            {takePhotoStatus == true && <TakePhoto onSelectedFile={selectedFileHandler}></TakePhoto>}
                                        </IonCol>
                                        <IonCol>
                                            <input
                                                type="file"
                                                accept="image/jpeg"
                                                onChange={handleFileChange}
                                            />
                                        </IonCol>
                                    </IonRow>
                                    {/*<IonRow>
                                        <form id='fileUpload' onSubmit={() => setShowPasswordModal(true)}>
                                            <input type='file' name='xImageFile' accept="image/*" enctype='multipart/form-data' onChange={(e) => setSelectedFile(e.target.files[0])}></input>
                                        </form>
                                    </IonRow>*/}
                                    <IonRow>
                                        <IonCol>
                                            <label for='noAttachment'>No Attachment</label>
                                        </IonCol>
                                        <IonCol>
                                            <input type='checkbox' id='noAttachment' onClick={() => handleEnterAttachement()}></input>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            {(authenticatedMerchent_context.accessRights[0] == 'admin'  || authenticatedMerchent_context.accessRights[0] == 'manager') && <IonButton id='gridResultColumnButton' disabled={disableExpensePayButton} onClick={() => paymentFunction([unitAmountRef.current.value, supplierPhoneRef.current, supplierNameRef.current, '74605_B_expense_projects', 'transfer', 'initial'])}> Transfer </IonButton>}
                                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton id='gridResultColumnButton' disabled={disableExpensePayButton} onClick={() => paymentFunction([unitAmountRef.current.value, supplierPhoneRef.current, supplierNameRef.current, '74605_B_expense_projects', 'deposit', 'initial'])}> Deposit </IonButton>}
                                            {authenticatedMerchent_context.accessRights[0] == 'admin'  && <IonButton id='gridResultColumnButton' disabled={disableExpensePayButton} onClick={() => paymentFunction([unitAmountRef.current.value, supplierPhoneRef.current, supplierNameRef.current, '74605_B_expense_projects', 'transfer', 'admin'])}>  admin_add </IonButton>}
                                            {/*{(authenticatedMerchent_context.accessRights[0] == 'admin'  || authenticatedMerchent_context.accessRights[0] == 'manager') && <IonButton id='gridResultColumnButton' disabled={disableExpensePayButton} onClick={() => submitPay_expense([unitAmountRef.current.value, supplierPhoneRef.current.value, supplierNameRef.current.value, '74605_B_expense', 'transfer', 'partial_paid', detailData.transactionID, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.paymentType])}> Transfer </IonButton>}
                                            {(authenticatedMerchent_context.accessRights[0] == 'admin'  || authenticatedMerchent_context.accessRights[0] == 'manager') && <IonButton id='gridResultColumnButton' disabled={disableExpensePayButton} onClick={() => submitPay_expense([unitAmountRef.current.value, supplierPhoneRef.current.value, supplierNameRef.current.value, '74605_B_expense', 'deposit', 'partial_paid', detailData.transactionID, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.paymentType])}> Deposit </IonButton>}
                                            {(authenticatedMerchent_context.accessRights[0] == 'admin'  || authenticatedMerchent_context.accessRights[0] == 'manager') && <IonButton id='gridResultColumnButton' disabled={true}  > PENDING </IonButton>}*/}
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonSlide>
                    </IonSlides>
                    
                    <IonButton className='button_closeModal_center' onClick={() => closeModalHandler(false)}>Cancel </IonButton>

                        {/*<EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>*/}                        
                        {/*<IonButton onClick={() => setShowPasswordModal(true)}> Add Expense </IonButton>*/}
                        </IonContent>
                    </IonModal>) : null
                }
            </React.Fragment>

    )
}